/** Korte feedbacktonen (geen externe assets). Uit bij prefers-reduced-motion. */

function reducedSound(): boolean {
  try {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch {
    return false;
  }
}

function playBlip(freq: number, durationSec: number, gain = 0.07): void {
  if (reducedSound()) return;
  try {
    const Ctx = window.AudioContext || (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const osc = ctx.createOscillator();
    const g = ctx.createGain();
    osc.type = 'sine';
    osc.frequency.setValueAtTime(freq, ctx.currentTime);
    g.gain.setValueAtTime(0.0001, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(gain, ctx.currentTime + 0.015);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + durationSec);
    osc.connect(g);
    g.connect(ctx.destination);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + durationSec + 0.02);
    ctx.resume?.().catch(() => {});
  } catch {
    /* ignore */
  }
}

/** Kort hoger piepje bij verzenden. */
export function playSendSound(): void {
  playBlip(880, 0.07, 0.06);
}

/** Zachter lager piepje bij binnenkomend antwoord. */
export function playReceiveSound(): void {
  playBlip(520, 0.11, 0.055);
}
